import React, { useState, useCallback } from 'react';
import Button from '@atlaskit/button';
import { Modal, Carousel, CarouselSlide } from '@atlassian/growth-pattern-library-modal';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import type { Props } from './types';

export const SplitPanelModal = ({ userCanUpgrade, upgradeUrl }: Props) => (
	<JSErrorBoundary
		id="splitPanelModal"
		packageName="jiraLossAversion"
		teamName="luna-growth"
		fallback="unmount"
	>
		<SplitPanelModalContent userCanUpgrade={userCanUpgrade} upgradeUrl={upgradeUrl} />
	</JSErrorBoundary>
);

export const SplitPanelModalContent = ({ userCanUpgrade, upgradeUrl }: Props) => {
	const [showModal, setShowModal] = useState(true);
	const onClose = useCallback(() => setShowModal(false), []);

	if (!showModal) {
		return <></>;
	}

	return (
		<Modal
			title="PLACEHOLDER:"
			subtitle="PLACEHOLDER: subtitle"
			onClose={onClose}
			testId="loss-aversion.ui.loss-aversion-modal.split-panel"
			actions={
				<Button onClick={onClose} appearance="primary">
					Cancel
				</Button>
			}
			right={
				<Carousel>
					<CarouselSlide title="Unlimited People">Carousel content</CarouselSlide>
				</Carousel>
			}
		>
			SplitPanelModal <br />
			{userCanUpgrade ? `can upgrade at link ${upgradeUrl}` : 'cant upgrade'}
		</Modal>
	);
};
